import React from 'react'
import image from '../../assets/homepage_logo.png'
import { Nav } from 'react-bootstrap'
import image2 from '../../assets/homepage_icon3.png';
const Topbar = () => {
  return (
    <div className="head-mid">
      <div className="container-fluid">
        <div className="row">
          {/* <div className="col-md-2">
            <div className="logo">
              <a href="index-2.html">
                <img src={image} alt="" className="logo-black" />
                <img src="assets/homepage_logo-w.png" alt="" className="logo-white" />
              </a>
            </div>
          </div> */}
          {/* <div className="col-md-3 d-block d-sm-none">
            <ul className="cart-lst float-right">
              {/* <li>
                <a href="#">
                  <em>Compare</em> <img src="images/icon1.png" alt="" />{" "}
                  <span>0</span>
                </a>
              </li>
              <li>
                <a href="#">
                  <em>Wishlist</em> <img src="images/icon2.png" alt="" />
                  <span>0</span>
                </a>
              </li>
              <li> 
                <a href="#">
                  <em>My Cart</em> <img src={image2} alt="" />
                  <span>0</span>
                </a>
              </li>
            </ul>
          </div> */}
          <div className="col-md-12">
            <Nav className="navbar navbar-expand-lg navbar-light">
              <div className="container-fluid">
                <a href="#" className="navbar-brand">
                <img src={image} alt="" className="logo-black" />
              </a>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                  <span className="navbar-toggler-icon"></span>
                </button>
                <div id="navbarSupportedContent" className="collapse navbar-collapse">
                  <ul className="navbar-nav mr-auto">
                  <li className="nav-item"><a href="" className="nav-link font-weight-bold text-uppercase">Home</a></li>
                    <li className="nav-item dropdown megamenu"><a href="#" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false" className="nav-link dropdown-toggle font-weight-bold text-uppercase dropdown-toggle">Mega Menu</a>
                      <div aria-labelledby="dropdownMenuButton1" className="dropdown-menu border-0 p-0 m-0">
                        <div className="container-fluid">
                          <div className="row bg-white rounded-0 m-0 shadow-sm">
                            <div className="col-lg-7 col-xl-8">
                              <div className="p-4">
                                <div className="row">
                                  <div className="col-lg-6 mb-4">
                                    <h6 className="font-weight-bold text-uppercase">MegaMenu heading</h6>
                                    <ul className="list-unstyled">
                                      <li className="nav-item"><a href="" className="nav-link text-small pb-0">Unique Features</a></li>
                                      <li className="nav-item"><a href="" className="nav-link text-small pb-0 ">Image Responsive</a></li>
                                      <li className="nav-item"><a href="" className="nav-link text-small pb-0 ">Auto Carousel</a></li>
                                      <li className="nav-item"><a href="" className="nav-link text-small pb-0 ">Newsletter Form</a></li>
                                    </ul>
                                  </div>
                                  <div className="col-lg-6 mb-4">
                                    <h6 className="font-weight-bold text-uppercase">MegaMenu heading</h6>
                                    <ul className="list-unstyled">
                                      <li className="nav-item"><a href="" className="nav-link text-small pb-0 ">Unique Features</a></li>
                                      <li className="nav-item"><a href="" className="nav-link text-small pb-0 ">Image Responsive</a></li>
                                      <li className="nav-item"><a href="" className="nav-link text-small pb-0 ">Auto Carousel</a></li>
                                      <li className="nav-item"><a href="" className="nav-link text-small pb-0 ">Newsletter Form</a></li>
                                    </ul>
                                  </div>
                                  <div className="col-lg-6 mb-4">
                                    <h6 className="font-weight-bold text-uppercase">MegaMenu heading</h6>
                                    <ul className="list-unstyled">
                                      <li className="nav-item"><a href="" className="nav-link text-small pb-0 ">Unique Features</a></li>
                                      <li className="nav-item"><a href="" className="nav-link text-small pb-0 ">Image Responsive</a></li>
                                      <li className="nav-item"><a href="" className="nav-link text-small pb-0 ">Auto Carousel</a></li>
                                      <li className="nav-item"><a href="" className="nav-link text-small pb-0 ">Newsletter Form</a></li>
                                    </ul>
                                  </div>
                                  <div className="col-lg-6 mb-4">
                                    <h6 className="font-weight-bold text-uppercase">MegaMenu heading</h6>
                                    <ul className="list-unstyled">
                                      <li className="nav-item"><a href="" className="nav-link text-small pb-0 ">Unique Features</a></li>
                                      <li className="nav-item"><a href="" className="nav-link text-small pb-0 ">Image Responsive</a></li>
                                      <li className="nav-item"><a href="" className="nav-link text-small pb-0 ">Auto Carousel</a></li>
                                      <li className="nav-item"><a href="" className="nav-link text-small pb-0 ">Newsletter Form</a></li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-5 col-xl-4 px-0 d-none d-lg-block megaimaga"></div>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li className="nav-item"><a href="" className="nav-link font-weight-bold text-uppercase">About</a></li>
                    <li className="nav-item"><a href="" className="nav-link font-weight-bold text-uppercase">Services</a></li>
                    <li className="nav-item"><a href="" className="nav-link font-weight-bold text-uppercase">Contact</a></li>
                    <li className="nav-item"><a href="" className="nav-link font-weight-bold text-uppercase">Shop</a></li>
                    <li className="nav-item"><a href="" className="nav-link font-weight-bold text-uppercase">Blog</a></li>
                    <li className="nav-item"><a href="" className="nav-link font-weight-bold text-uppercase">Career</a></li>
                    <li className="nav-item"><a href="" className="nav-link font-weight-bold text-uppercase">Feedback</a></li>
                    <li className="nav-item nav-btn">
                      <a href="make-pc.html" className="btn-make">
                        <img src="images/pc-icon.png" alt="" /> Make Your PC
                      </a></li>
                  </ul>
                </div>
              </div>
            </Nav>
          </div>
        </div>
      </div>
    </div>

  )
}

export default Topbar